<template>
  <div class="docob" v-if="loc" :class="{ 'act' : selectedLoc == loc.id}">
    <div class="top" :style="styleUp">
      <div class="fach">{{ loc.fach }}</div>
      <div class="name">{{ loc.name }}</div>
      <div class="info">
        <div class="info_left">
          <div class="streetaddress">{{ loc.st }} {{ loc.ha }}</div>
          <div class="plzcity">{{ loc.pl }} {{ loc.o }}</div>
        </div>
        <div class="info_right contactinfo">
          <span class="tel" v-if="loc.te && loc.te.trim().length"
            ><a :href="'tel:' +  loc.te ">Tel.: {{ loc.te }}</a></span
          >
          <span class="fax" v-if="loc.f && loc.f.trim().length"
            >Fax: {{ loc.f }}</span
          >
        </div>
        <div class="clearer"></div>
        <div class="email emaillink" v-if="loc.e && loc.e.trim().length">
          E-Mail: <a :href="'mailto:' + loc.e">{{ loc.e }}</a>
        </div>
        <br />
        <div class="web urllink" v-if="loc.w && loc.w.trim().length">
          Web: <a :href="loc.w" target="_blank">{{ loc.w }}</a>
        </div>
        <div class="clearer"></div>
      </div>
    </div>
    <div class="bottom">
      <Accordion v-if="loc.bff && loc.bff.trim().length">
        <AccordionTab header="Barrierefreiheit">
          {{ loc.bff }}
        </AccordionTab>
      </Accordion>

      <Accordion>
        <AccordionTab
          header="Fremdsprachen"
          v-if="loc.fss && loc.fss.trim().length"
        >
          {{ loc.fss }}
        </AccordionTab>
      </Accordion>

      <Accordion v-if="loc.zbb && loc.zbb.trim().length">
        <AccordionTab header="Zusatzbezeichnungen">
          {{ loc.zbb }}
        </AccordionTab>
      </Accordion>

      <Accordion v-if="loc.ptt && loc.ptt.length">
        <AccordionTab header="Psychotherapie">
          <div class="psycho_line" v-for="(ptt, index) in loc.ptt" :key="`ptt-${index}`">
            {{ ptt.ptv }} für {{ ptt.pta }} in {{ ptt.pts }}
          </div>
        </AccordionTab>
      </Accordion>

      <Accordion v-if="loc.ss && loc.ss.length">
        <AccordionTab header="Sprechzeiten">
          <table class="sz_table">
            <tr v-for="ssUp in loc.sss" :key="ssUp.day">
              <td class="day">{{ ssUp.day }}</td>
              <td>
                <table class="hourstable">
                  <tr v-for="hourUp in ssUp.hours" :key="ssUp.day+hourUp.v">
                    <td class="hours">{{ hourUp.v }} - {{ hourUp.b }}</td>
                    <td class="comments">
                      <div
                        class="typ"
                        v-if="hourUp.typ && hourUp.typ.trim().length"
                      >
                        {{ hourUp.typ }}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <!-- </td>  -->
            </tr>
          </table>

          <div
            class="sprechzeiten_header orange"
            v-if="loc.sonss && loc.sonss.length"
          >
            <p><b>Sondersprechzeiten</b></p>
          </div>

          <p
            class="sprechzeiten_header sprechstundep"
            v-for="sonssUp in loc.sonss"
            :key="sonssUp.t"
          >
            <span v-if="sonssUp.t && sonssUp.t.trim().length"> ,&nbsp; </span>
            <span v-if="sonssUp.dVon === sonssUp.dBis">{{ sonssUp.dVon }}</span>
            <span v-else>{{ sonssUp.dVon }} - {{ sonssUp.dBis }}</span>
            , <b>{{ sonssUp.v }} - {{ sonssUp.b }}</b>
            <span v-if="sonssUp.f && sonssUp.f.trim().length">
              {{ sonssUp.f }}</span
            >
          </p>
        </AccordionTab>
      </Accordion>
    </div>
  </div>
</template>

<script>
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import { ref } from "vue";

export default {
  props: ["loc", "selectedLoc", "indexIn"],
  components: {
    Accordion,
    AccordionTab,
  },
  setup(props) {
    const indexUp = props.indexIn + 1;
    const styleUp = indexUp <= 10 ? `background-image:url(/typo3conf/ext/arztsuchevue/Resources/Public/Images/Markers/${indexUp}.svg)` : '';
    return { styleUp }
  }
};
</script>

<style>

</style>